import { Input } from '@/components/common/Input'
import { StepShell } from '../StepShell'

const FIELDS = [
  { key: 'blood_pressure', label: 'Blood pressure', suffix: 'mmHg', placeholder: '120/80' },
  { key: 'pulse_rate', label: 'Pulse rate', suffix: '/ min', placeholder: '72' },
  { key: 'respiratory_rate', label: 'Respiratory rate', suffix: '/ min', placeholder: '16' },
  { key: 'temperature', label: 'Temperature', suffix: '°F', placeholder: '98.6' },
  { key: 'spo2', label: 'SpO₂', suffix: '%', placeholder: '98' },
  { key: 'random_blood_sugar', label: 'Random blood sugar', suffix: 'mg/dL', placeholder: '110' },
]

const DEFAULT = Object.fromEntries(FIELDS.map((f) => [f.key, '']))

export function VitalsStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 6 — Phase 2"
      title="Vitals"
      description="Baseline measurements at the time of consultation."
    >
      <div className="overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-ink-100">
        <table className="w-full text-sm">
          <thead className="bg-ink-50/60">
            <tr>
              <th className="px-4 py-3 text-left label-text">Vital</th>
              <th className="px-4 py-3 text-left label-text">Value</th>
            </tr>
          </thead>
          <tbody>
            {FIELDS.map((f) => (
              <tr key={f.key} className="border-t border-ink-100">
                <td className="px-4 py-3 font-semibold text-ink-800">{f.label}</td>
                <td className="px-4 py-2">
                  <div className="flex items-center gap-2">
                    <Input
                      value={v[f.key]}
                      onChange={(e) => set({ [f.key]: e.target.value })}
                      placeholder={f.placeholder}
                      className="max-w-[200px]"
                    />
                    <span className="text-xs font-medium text-ink-500">{f.suffix}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </StepShell>
  )
}
